import { produce } from 'immer'
import createReducer from "./reducerUtils"

const initialState = {
    assessments: null,
    assessmentDefs: null,
    assessment: {},
    assessmentTableViewIndex: 0,
    id: null,
    assessmentScreenView: null,
    updateAssessmentScreenViewFlag: null,
    selectedAssessmentDefs: [],
    selectedAssessmentDef: null,
    interventionProfiles: {},

    // מאפיין האם אנחנו במצב של ביצוע מבדקים  
    // הדגל נדלק שנכנסים למסך ביצוע מבדק 
    // נכבה כאשר הסתיים הביצוע והסתיימה העלאת הקבצים 
    // (ייתכן שחלק מהעלאות נכשלו אבל אין העלאות ברקע)
    isInAssessmentMode: false,
    uploadingAssessmentIds: [],
    stuckAssessmentIds: [],

    // חלק ממשתנים אלו לא בשימוש
    progress: {
        "1": {
            progress: 4
        },
        "2": {
            progress: 10
        },
        "3": {
            progress: 30
        },
        "4": {
            progress: 0
        }
    },
    assessmentIds: [],
    assessmentDef: null,
    assessmentsGroup: [],
    selectedAssessment: null,
    assessmentFilters: {
        year: null,
        semester: null,
        assessment_def: null,
        gender: null,
        category: null
    },
    statusFilters: {},
    selectedAssessments: [],
    categories: [],
}

const assessment = {
    setAssessmentIds(state, action) {
        state.assessmentIds = action.payload
    },
    setIsInAssessmentMode(state, action) {
        state.isInAssessmentMode = action.payload
    },
    addUploadingAssessmentId(state, action) {
        const id = action.payload;

        // Remove from stuck assessments
        state.stuckAssessmentIds =
            state.stuckAssessmentIds.filter(stuckId => stuckId !== id);

        // Add to uploading assessments if not already present
        if (!state.uploadingAssessmentIds.includes(id)) {
            state.uploadingAssessmentIds.push(id);
        }
    },

    addStuckAssessmentId(state, action) {
        const id = action.payload;

        // Remove from uploading assessments
        state.uploadingAssessmentIds =
            state.uploadingAssessmentIds.filter(uploadingId => uploadingId !== id);

        // Add to stuck assessments if not already present
        if (!state.stuckAssessmentIds.includes(id)) {
            state.stuckAssessmentIds.push(id);
        }
    },

    removeUploadingAssessmentId(state, action) {
        const id = action.payload;

        state.uploadingAssessmentIds =
            state.uploadingAssessmentIds.filter(uploadingId => uploadingId !== id);
    },
    removeStuckAssessmentId(state, action) {
        const id = action.payload;

        state.stuckAssessmentIds =
            state.stuckAssessmentIds.filter(stuckId => stuckId !== id);
    },
    setStuckAssessmentIds(state, action) {
        const newAssessmentIds = action.payload || [];

        newAssessmentIds.forEach(id => {
            if (!state.stuckAssessmentIds.includes(id)) {
                state.stuckAssessmentIds.push(id);
            }
        });
    },
    setAssessmentTableViewIndex(state, action) {
        state.assessmentTableViewIndex = action.payload
    },
    updateAssessmentFilters(state, action) {
        state.assessmentFilters = { ...state.assessmentFilters, ...action.payload }
    },
    setSelectedAssessments(state, action) {
        state.selectedAssessments = action.payload
    },
    setAssessmentScreenView(state, action) {
        state.assessmentScreenView = action.payload
    },
    setUpdateAssessmentScreenViewFlag(state, action) {
        state.updateAssessmentScreenViewFlag = action.payload
    },
    cleanSelectedAssessments(state, action) {
        state.selectedAssessments = []
    },
    setAssessmentFilters(state, action) {
        state.assessmentFilters = action.payload
    },
    cleanAssessmentFilters(state, action) {
        state.assessmentFilters = {
            year: null,
            semester: null,
            assessment_def: null,
            gender: null,
            category: null
        }
    },
    updateStatusFilters(state, action) {
        state.statusFilters = { ...state.statusFilters, ...action.payload }
    },
    setStatusFilters(state, action) {
        state.statusFilters = action.payload
    },
    cleanStatusFilters(state, action) {
        state.statusFilters = {}
    },
    setAssessments(state, action) {
        state.assessments = action.payload
    },
    cleanAssessments(state, action) {
        state.assessments = null
    },
    setSelectedAssessment(state, action) {
        state.selectedAssessment = action.payload
    },
    setAssessmentsGroup(state, action) {
        state.assessmentsGroup = action.payload
    },
    setSelectedAssessmentDefs(state, action) {
        state.selectedAssessmentDefs = action.payload
    },
    setSelectedAssessmentDef(state, action) {
        state.selectedAssessmentDef = action.payload
    },
    updateSelectedAssessmentDef(state, action) {
        state.selectedAssessmentDef = { ...state.selectedAssessmentDef, ...action.payload }
    },
    setAssessmentDef(state, action) {
        state.assessmentDef = action.payload
    },
    updateAssessment(state, action) {
        state.assessment = { ...state.assessment, ...action.payload }
    },
    startProgress(state, action) {
        let key = action.payload
        state.progressIndication[key] = { ...state.progressIndication[key], start: true }
    },
    setAssessmentDefs(state, action) {
        state.assessmentDefs = action.payload
    },
    setAssessment(state, action) {
        state.assessment = action.payload
    },
    setId(state, action) {
        state.id = action.payload
    },
    setInterventionProfiles(state, action) {
        state.interventionProfiles = action.payload
    }
}

export default produce(
    (state, action) => createReducer(state, action, assessment),
    initialState
)

